// extracted by mini-css-extract-plugin
export default {"cashbackRow":"CashbackFormSkeleton_cashbackRow__cWjBd","cashbackInput":"CashbackFormSkeleton_cashbackInput__C+WP5","actions":"CashbackFormSkeleton_actions__3ENqm"};